import React, { FC, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { CustomSpinner } from '@yakoffice/custom-spinner';
import { useGameEnvironments } from '../../../loaders/useGameEnvironments';
import { GameEnvironments } from './GameEnvironments';
import { usePageTitle } from '../pageTitleContext/PageTitleContext';
import { IGameEnvironment } from '../../../model/gameEnvironment/GameEnvironment';

export const GameEnvironmentsContainer: FC = observer(() => {

    const [callbackTrigger, setCallbackTrigger] = useState<number>(0);

    const [activeGameEnvironment, setActiveGameEnvironment] = useState<number | null>();
    const [newGameEnvironment, setNewGameEnvironment] = useState<boolean>(false);

    const gameEnvironmentsResult = useGameEnvironments(callbackTrigger);
    const { setPageTitle } = usePageTitle();

    setPageTitle(['Game Environments']);

    const updateCallbackTrigger = () => {
        setCallbackTrigger(callbackTrigger + 1);
    };

    const setTheActiveGameEnvironment = (gameEnvironment: IGameEnvironment | undefined) => {
        if (gameEnvironment === undefined)
            setActiveGameEnvironment(null);
        else
            setActiveGameEnvironment(gameEnvironment.id);
    };

    return gameEnvironmentsResult.isLoaded && gameEnvironmentsResult.gameEnvironments != null ? (
        <GameEnvironments
            gameEnvironments={gameEnvironmentsResult.gameEnvironments}
            updateCallbackTrigger={updateCallbackTrigger}
            activeGameEnvironment={gameEnvironmentsResult.gameEnvironments.find((gameEnvironment) => gameEnvironment.id === activeGameEnvironment)}
            setActiveGameEnvironment={setTheActiveGameEnvironment}
            newGameEnvironment={newGameEnvironment}
            setNewGameEnvironment={setNewGameEnvironment}
        />
    ) : (
        <CustomSpinner spinnerText={'Refreshing game environments...'} />
    );

});
